'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;
// import Input from 'react-toolbox/lib/input';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _customers = require('redux/modules/customers');

var _components = require('components');

var _containers = require('containers');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _button = require('react-toolbox/lib/button');

var _kunaUtils = require('../../utils/kunaUtils');

var _regexUtils = require('../../utils/regexUtils');

var _scriptLoader = require('../../utils/scriptLoader');

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requiredCollaborator = 'support@getkuna.com';

var Zendesk = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    customerEmail: state.customers.email,
    cameras: state.customers.cameras,
    firmware: state.firmware,
    zendesk: state.customers.zendesk
  };
}, (0, _extends3.default)({}, authActions, { loadCustomer: _customers.load })), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Zendesk, _Component);

  function Zendesk(props) {
    (0, _classCallCheck3.default)(this, Zendesk);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Zendesk.__proto__ || (0, _getPrototypeOf2.default)(Zendesk)).call(this, props));

    _this.state = {
      // scriptLoading: true,
      // addedContactEmail: false,
      client: null,
      customerName: null,
      customerTicketURL: null,
      ticketId: null,
      emails: [],
      cameras: []
      // loginEmail: null,
      // loginPassword: null,
    };
    _this.zendeskLoaded = _this.zendeskLoaded.bind(_this);
    _this.zendeskResize = _this.zendeskResize.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.client = null;
    return _this;
  }

  (0, _createClass3.default)(Zendesk, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _scriptLoader2.default)('https://assets.zendesk.com/apps/sdk/2.0/zaf_sdk.js', function () {
        return window.ZAFClient;
      }, this.zendeskLoaded);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.zendeskResize();
    }

    /**
     * This is needed because we must tell the zendesk app whenever re-size
     */

  }, {
    key: 'zendeskResize',
    value: function zendeskResize() {
      // Add one - otherwise we sometimes scroll just a little bit
      var height = document.documentElement.offsetHeight + 1;
      if (this.state.client) {
        this.state.client.invoke('resize', { width: '100%', height: height });
      }
    }

    // loadExtScript calls this function when the script has loaded
    // successfully.

  }, {
    key: 'zendeskLoaded',
    value: function zendeskLoaded() {
      var _this2 = this;

      // this.setState({ scriptLoading: false });
      var client = window.ZAFClient.init();
      this.setState({ client: client });
      this.zendeskResize();

      if (client) {
        client.get(['ticket']).then(function (data) {
          var ticket = data.ticket;
          var emailsFound = [];
          var camerasFound = [];

          // console.log('ticket' + JSON.stringify(ticket, null, 2));

          // Require that the requiredCollaborator is included in the CC list
          if (!ticket.collaborators.find(function (user) {
            return user.email === requiredCollaborator;
          })) {
            client.invoke('ticket.collaborators.add', {
              email: requiredCollaborator
            });
            // this.setState({ addedContactEmail: true });
          }

          // Get the customer's name and store email address in emailsFound
          if (ticket.requester) {
            if (ticket.requester.name) {
              _this2.setState({ customerName: ticket.requester.name });
            }
            if (ticket.requester.email) {
              emailsFound.push(ticket.requester.email.toLowerCase());
            }
          }

          // Get the customer's name and store email address in emailsFound
          if (ticket.assignee) {
            if (ticket.assignee.user) {
              _this2.setState({ ticketAgentEmail: ticket.assignee.user.email });
            }
          }
          _this2.setState({ ticketId: ticket.id });
          _this2.setState({
            customerTicketURL: 'https://kuna.zendesk.com/agent/tickets/' + ticket.id
          });

          // Filter comments in ticket by end user
          var userComments = ticket.comments.filter(function (comment) {
            return comment.author.role === 'end-user';
          });

          // (TODO: convert to for loop)
          // eslint-disable-next-line array-callback-return
          userComments.map(function (comment) {
            var foundEmails = comment.value.match(_regexUtils.emailRegex);
            var foundEmailsLower = foundEmails ? foundEmails.map(function (email) {
              return email.toLowerCase();
            }) : null;
            // console.log('found emails: ' + JSON.stringify(foundEmailsLower, null, 2));
            if (foundEmailsLower) {
              emailsFound.push.apply(emailsFound, (0, _toConsumableArray3.default)(foundEmailsLower));
            }
            if (comment.author.email) {
              emailsFound.push(comment.author.email.toLowerCase());
            }

            var camsInTicket = comment.value.match(_kunaUtils.cameraSnRegex);
            if (camsInTicket) {
              camerasFound.push.apply(camerasFound, (0, _toConsumableArray3.default)(camsInTicket));
            }
          });

          var uniqueEmails = (0, _from2.default)(new _set2.default(emailsFound)).filter(function (email) {
            if (email === 'contact@kunasystems.com' || email === 'support@getkuna.com') {
              return false;
            }
            return true;
          });

          _this2.setState({ emails: uniqueEmails });
          _this2.setState({ cameras: (0, _from2.default)(new _set2.default(camerasFound)) });
        });
        // client.invoke('comment.appendHtml', '<h1>Heading</>');
      } else {
        // If client can't load
        this.setState({ emails: ['sean@getkuna.com'] });
      }
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      event.preventDefault();
      var input = this.refs.username;
      var password = this.refs.password;
      this.props.login(input.value, password.value);
      input.value = '';
      password.value = '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var user = this.props.user;
      var _state = this.state,
          emails = _state.emails,
          cameras = _state.cameras,
          customerName = _state.customerName,
          customerTicketURL = _state.customerTicketURL,
          ticketAgentEmail = _state.ticketAgentEmail,
          ticketId = _state.ticketId,
          zdAddedContactEmail = _state.zdAddedContactEmail;

      return _react2.default.createElement(
        'div',
        null,
        user && emails[0] !== undefined && emails.map(function (email) {
          return _react2.default.createElement(
            _containers.CustomerWrapper,
            {
              key: email,
              email: email,
              zdTicketUrl: customerTicketURL,
              onUpdate: _this3.zendeskResize,
              zdTicketId: ticketId,
              customerName: customerName,
              ticketAgentEmail: ticketAgentEmail,
              zdAddedContactEmail: zdAddedContactEmail,
              isZendesk: true
            },
            _react2.default.createElement(
              _components.Customer,
              null,
              _react2.default.createElement(_components.ZendeskCamera, null)
            )
          );
        }),
        user && cameras[0] !== undefined && cameras.map(function (camera) {
          return _react2.default.createElement(
            'div',
            null,
            'Camera found in ticket:',
            camera
          );
        }),
        !user && _react2.default.createElement(
          'form',
          { onSubmit: this.handleSubmit },
          _react2.default.createElement(
            'h3',
            null,
            'Kuna Internal'
          ),
          _react2.default.createElement(
            'section',
            null,
            _react2.default.createElement('input', {
              type: 'text',
              label: 'Username',
              name: 'username',
              ref: 'username'
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement('input', {
              type: 'password',
              label: 'Password',
              name: 'password',
              ref: 'password'
            }),
            _react2.default.createElement(_button.Button, { label: 'Log in', raised: true, primary: true })
          )
        )
      );
    }
  }]);
  return Zendesk;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  customerEmail: _react.PropTypes.object,
  cameras: _react.PropTypes.object,
  firmware: _react.PropTypes.object,
  zendesk: _react.PropTypes.object,
  loadCustomer: _react.PropTypes.func.isRequired,
  login: _react.PropTypes.func
}, _temp)) || _class);
/* <form onSubmit={this.handleSubmit}>
      <h1>Kuna Internal</h1>
      <input type="text" ref="username" placeholder="Email" className="username"/>
      <input type="password" ref="password" placeholder="Password" className="password"/>
      <button onClick={this.handleSubmit}>
        {/* <i className="fa fa-sign-in"/>{' '} *} Log In
      </button>
  </form> */

exports.default = Zendesk;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Zendesk/Zendesk.js
 ** module id = 1400
 ** module chunks = 0
 **/